import {Accordion} from 'src/components/accordion/accordion';

import styles from './why-section.module.scss';

const tabs = [
    {
        title: 'Why now',
        content:
            'The pressure to lead through change, understand AI, and develop stronger communication skills is more intense than ever. Skills gaps need to be filled — and fast.',
    },
    {
        title: 'Why us',
        content:
            'With our deep understanding of learning modalities, agile approach to technical experimentation, and the real-world expertise of our 80,000 instructors, we’re uniquely equipped to develop and deliver the cutting edge learning tools needed now.',
    },
    {
        title: 'Why it’s awesome',
        content:
            'We’re incubating new ways of learning, rolling them out to our talented instructors, and giving our learners groundbreaking experiences that help them level up key skills.',
    },
];

const WhySection = () => {
    return (
        <div className={styles.container} id="studio-info">
            <div className={styles.title}>Why we created the Udemy Innovation Studio</div>
            <Accordion tabs={tabs} />
        </div>
    );
};

export {WhySection};
